
  import { Vue, prop, Options } from "vue-class-component";

  class Props {
    // list option value & label dropdown
    searchByOptions = prop<any[]>({
      default: [],
      type: Array,
    });
    // default value for dropdown list
    defaultSearchBy = prop<string>({
      default: "",
      type: String,
    });
    // placeholder for search input
    placeholderSearch = prop<string>({
      default: "",
      type: String,
    });
    // placeholder for dropdown list
    placeholderFilter = prop<string>({
      default: "",
      type: String,
    });
    modelValue = prop<string>({
      default: "",
      type: String
    });
    searchBy = prop<any>({
      type: Object
    });
  }

  @Options({
    emits: ["searchBy", "search"],
  })

  export default class DropdownSearch extends Vue.with(Props) {
    openSelect = false;
    searchValue = "";
    defaultOption = this.defaultSearchBy;
    isFilter = false;

    get searchSelectedOption() {
      return this.searchBy || {
        label: "",
        value: ""
      };
    }

    set searchSelectedOption(val: any) {
      this.$emit("update:searchBy", val);
    }

    closeSelect() {
      this.openSelect = false;
    };

    closeExpandSelect() {
      this.openSelect = !this.openSelect;
    };

    isActive(option: any) {
      return (
        this.searchSelectedOption.value === option.value ||
        this.defaultOption === option.label
      );
    };

    onSelect(option: object) {
      if (this.isActive(option)) {
        this.searchSelectedOption = {};
      } else {
        this.defaultOption = "";
        this.searchSelectedOption = option;
      }
      this.openSelect = false;
    };

    onSearch(search: any) {
      this.isFilter = false;
      const value = search?.target.value;
      this.searchValue = value;
      this.$emit("update:modelValue", this.searchValue);
    };
    
    onKeyDown(e: any) {
      if (e.key === "Enter") {
        if (this.searchValue && this.searchValue.length < 3) return;
        const searchByOptionValue =
          this.defaultOption
          ? this.searchByOptions.find((item: any) => item.label === this.defaultOption)
          : this.searchSelectedOption;
        
        this.isFilter = true;
        this.openSelect = false;
        this.$emit("update:modelValue", this.searchValue);
        this.$emit("update:searchBy", this.searchByOptions);
        this.$emit("search", this.searchValue);
        this.$emit("searchBy", searchByOptionValue);
      }
    }

    onClear() {
      this.isFilter = false;
      this.searchValue = "";
      (document.getElementById(`${this.$attrs.id}_input_search`) as any).value = "";
      this.$emit("update:modelValue", "");
      this.$emit("update:searchBy", this.searchSelectedOption);
      this.$emit("search", "");
      this.$emit("searchBy", this.searchSelectedOption);
    }
  }
  